export class SIQArticleMessageTheme {
  cardTitleColor = "null";
  articleTitleColor = "null";
  authorTextColor = "null";
  backgroundColor = "null";
}
//# sourceMappingURL=SIQArticleMessageTheme.js.map